import { ChartFooterRow, FooterLabeledSelect } from "./AnalyticsChartControls";

interface ChartViewFooterProps {
  hasMultipleViews: boolean;
  selectedViewId: string;
  setSelectedViewId: (viewId: string) => void;
  viewItems: { label: string; value: string }[];
}

const ChartViewFooter = ({
  hasMultipleViews,
  selectedViewId,
  setSelectedViewId,
  viewItems,
}: ChartViewFooterProps) => {
  if (!hasMultipleViews) {
    return null;
  }

  return (
    <div className="mt-3 shrink-0">
      <ChartFooterRow>
        <FooterLabeledSelect
          label="View"
          value={selectedViewId}
          onValueChange={setSelectedViewId}
          items={viewItems}
        />
      </ChartFooterRow>
    </div>
  );
};

export default ChartViewFooter;
